import { render, staticRenderFns } from "./RsaSchedaProgrammaRiabilitativoEditComponent.vue?vue&type=template&id=914ed598&scoped=true"
import script from "./RsaSchedaProgrammaRiabilitativoEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaProgrammaRiabilitativoEditComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaSchedaProgrammaRiabilitativoEditComponent.vue?vue&type=style&index=0&id=914ed598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914ed598",
  null
  
)

export default component.exports